import CustomEventDispatcher from './CustomEventDispatcher';

class WebSocketService extends CustomEventDispatcher {
  constructor() {
    super();
    this.socket = null;
  }

  rootUrl() {
    if (process.env.NODE_ENV === 'development') {
      console.log('WebSocket URL:', process.env.VUE_APP_WEBSOCKET_URL);
      return process.env.VUE_APP_WEBSOCKET_URL;
    }
    return window.location.origin.replace('http', 'ws'); // Gebruik de huidige origin voor productie/acceptatie
  }

  connect() {
    const url = this.rootUrl();
    if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
      this.socket = new WebSocket(url);
    }

    this.socket.onopen = () => {
      console.log('WebSocket is open now.');
    };

    this.socket.onmessage = (event) => {
      const response = JSON.parse(event.data);
      const customEvent = new CustomEvent(response.eventType, { detail: response.data });
      setTimeout(() => {
        this.dispatchEvent(customEvent);
      }, 100);
    };

    this.socket.onerror = (error) => {
      console.error('WebSocket error: ', error);
    };

    this.socket.onclose = (event) => {
      console.log('WebSocket is closed now. Trying to reconnect', event);
      setTimeout(() => {
        this.connect();
      }, 1000);
    };
  }

  send(path, data) {
    this.socket.send(JSON.stringify({ path, data }));
  }

  disconnect() {
    if (this.socket) {
      this.socket.close();
    }
  }
}

export default WebSocketService;
